import React from "react";
import { Button, Space, Tag, Tooltip } from "antd";
import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  PoweroffOutlined,
} from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useNavigate } from "react-router-dom"; // Import useNavigate here

const SortableClubRow = ({
  club,
  loading,
  updatingStatus,
  searchTerm,
  formatDate,
  handleToggleActive,
  openViewModal,
  openEditModal,
  openDeleteModal,
  isDragging = false,
  isOverlay = false,
  isDragEnabled = true,
}) => {
  const navigate = useNavigate(); // ✅ Correct: useNavigate inside component

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isSortableDragging,
  } = useSortable({
    id: club.id,
    disabled: !isDragEnabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isSortableDragging ? 0.5 : 1,
    backgroundColor: isSortableDragging ? "#f0f7ff" : "transparent",
    ...(isOverlay && {
      opacity: 0.9,
      backgroundColor: "#f8f9fa",
    }),
  };

  const dragHandleProps = isDragEnabled ? { ...attributes, ...listeners } : {};

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={isDragging ? "dragging-row" : ""}
    >
      <td style={{ width: "40px", textAlign: "center" }}>
        {isDragEnabled && (
          <span
            {...dragHandleProps}
            style={{
              cursor: "grab",
              fontSize: "18px",
              color: "#666",
              display: "inline-block",
              padding: "4px",
            }}
            title="Drag to reorder"
          >
            ⋮⋮
          </span>
        )}
      </td>
      <td>{club.name || "N/A"}</td>
      <td className="description-cell">
        {club.description && club.description.length > 50
          ? `${club.description.substring(0, 50)}...`
          : club.description || "N/A"}
      </td>
      <td>{club.created_by_email || "N/A"}</td>
      <td>{club.members_count || "0"}</td>
      <td>{formatDate(club.created_at)}</td>
      <td>{formatDate(club.updated_at)}</td>
      <td>
        <Tag color={club.is_active ? "green" : "default"}>
          {club.is_active ? "Active" : "Inactive"}
        </Tag>
      </td>
      <td>
        <Space size="small">
          <Tooltip title={club.is_active ? "Deactivate" : "Activate"}>
            <Button
              className="btn-toggle-active"
              size="small"
              danger={!!club.is_active}
              type={club.is_active ? "default" : "primary"}
              icon={<PoweroffOutlined />}
              onClick={() => handleToggleActive(club)}
              disabled={loading || updatingStatus}
            />
          </Tooltip>

          {/* View button with navigation */}
          <Tooltip title="View">
            <Button
              className="btn-view"
              type="primary"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => navigate(`/clubs/details/${club.id}`)}
              disabled={loading}
            />
          </Tooltip>

          {/* Edit button */}
          <Tooltip title="Edit">
            <Button
              className="btn-edit"
              type="primary"
              size="small"
              style={{ background: "#52c41a", borderColor: "#52c41a" }}
              icon={<EditOutlined />}
              onClick={() => openEditModal(club)}
              disabled={loading}
            />
          </Tooltip>

          {/* Delete button */}
          <Tooltip title="Delete">
            <Button
              className="btn-delete"
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => openDeleteModal(club)}
              disabled={loading}
            />
          </Tooltip>
        </Space>
      </td>
    </tr>
  );
};

export default SortableClubRow;
